import { parse } from 'date-fns/fp';
import { SHORT_DATE_FORMAT } from '../../constants';
export var parseShortDate = parse(new Date(), SHORT_DATE_FORMAT);
export default parseShortDate;